import { Spinner, SpinnerBall } from './spinner.component';

export const SPINNER_DECLARATIONS: any[] = [
  Spinner,
  SpinnerBall,
];
